import type { TicketDetails } from '../../domain/types'
import type { TicketDetailsDto } from '../dto/ticketDetails.dto'
import { adaptTicketHistory } from './ticketHistory.adapter'
import { ANONYMOUS_CUSTOMER, isTerminalCustomerEmail } from '../../domain/anonymousCustomer'

export function adaptTicketDetails(dto: TicketDetailsDto): TicketDetails {
  return {
    accessKey: dto.accessKey ?? null,
    activities: adaptTicketHistory(dto),
    customDatas: (dto.customDatas ?? []).map((field) => ({
      title: field.title || field.metadataKey || 'Campo personalizado',
      metadataKey: field.metadataKey ?? '',
      value: field.value == null ? null : String(field.value),
    })),
    smartCode: dto.smartCode ?? null,
    client: dto.client ? {
      name: isTerminalCustomerEmail(dto.client.email) ? ANONYMOUS_CUSTOMER.nome : dto.client.name ?? '',
      email: dto.client.email ?? null,
      phone: dto.client.phone ?? null,
    } : null,
    priority: dto.priority == null ? null : String(dto.priority),
    providerName: dto.provider?.name ?? null,
    locationName: dto.location?.name ?? null,
    locationAddress: dto.location?.address ?? null,
    serviceName: dto.service?.name ?? null,
    sessionStart: dto.session?.estimatedStart ?? null,
    sessionEnd: dto.session?.estimatedEnd ?? null,
    prevision: dto.prevision ?? null,
    attendanceType: dto.attendanceType ?? null,
  }
}
